<template>
  <div v-if="news">
    <div class="text-header">
      <prismic-rich-text
        id="single-info-header"
        :class="`mist-${language}-h1`"
        :field="news.primary.title"
        class="title invisible"
      />
    </div>
    <div class="columns is-justify-content-center">
      <div class="column is-8">
        <div class="img-pd">
          <div
            id="single-info-img"
            class="img-news invisible"
            :style="{
              backgroundRepeat: 'no-repeat',
              backgroundSize: 'cover',
              backgroundPosition: '50% 50%',
              backgroundImage: `url(` + news.primary.img.url + ')',
            }"
          />
          <!-- <img :src="news.primary.img.url" style="height: 507px" /> -->
        </div>
        <prismic-rich-text
          id="single-info-text"
          :class="`mist-${language}-p invisible`"
          class="info-news"
          :field="news.primary.info"
        />
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
export default {
  data() {
    return {
      header: null,
      title: null,
      news: null,
    };
  },
  computed: {
    ref() {
      return this.$store.getters["cms/ref"];
    },
    language() {
      return this.$store.getters["language/language"];
    },
    info() {
      return this.$router.currentRoute.params.name;
    },
  },
  watch: {
    language() {
      this.title = this.$router.currentRoute.params.name;
      this.getNewsParagraph();
    },
  },
  mounted() {
    this.title = this.$router.currentRoute.params.name;
    this.getNewsParagraph();
    const me = this;
    const interval = setInterval(function () {
      if ($(`#single-info-header`).length > 0) {
        me.setAnimation();
        $(document).scroll(me.setAnimation);
        clearInterval(interval);
      }
    }, 500);
  },
  beforeDestroy() {
    const me = this;
    $(document).off("scroll", me.setAnimation);
  },
  methods: {
    async getNewsParagraph() {
      const params = {
        ref: this.ref,
        q: `[[at(document.tags, ["${this.info}","${this.language}"])]]`,
      };
      const res = await this.$http.get(
        process.env.VUE_APP_URL + "/api/v2/documents/search",
        { params }
      );
      this.news = res.data.results[0].data.body[0];
    },
    setAnimation() {
      const height = $(window).scrollTop() + $(window).height();
      if (height > $(`#single-info-header`).offset().top) {
        $(`#single-info-header`)
          .addClass("animate__animated animate__fadeIn")
          .removeClass("invisible");
      }
      if (height > $(`#single-info-img`).offset().top) {
        $(`#single-info-img`)
          .addClass("animate__animated animate__fadeIn")
          .removeClass("invisible");
      }
      if (height > $(`#single-info-text`).offset().top) {
        $(`#single-info-text`)
          .addClass("animate__animated animate__fadeInUp")
          .removeClass("invisible");
      }
    },
  },
};
</script>
<style>
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translate3d(0, 100px, 0);
  }
  to {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }
}
</style>
<style scoped>
.img-news {
  height: 507px;
  width: 100%;
}
.title {
  padding: 6px 0 14px;
  margin: 0px;
}
.img-pd {
  padding: 62px 0 45px;
}
h2 {
  font-weight: 600 !important;
}
>>> h3 {
  font-weight: 600 !important;
  font-size: 26px !important;
  color: #272727;
}
>>> h5 {
  font-weight: 600 !important;
}
.text-header {
  padding: 39px 0 33px;
  border-bottom: 2px solid #002a65;
}
.info-news {
  padding-bottom: 90px;
  text-align: left;
}
@media (max-width: 768px) {
  .text-header {
    padding: 40px 0;
  }
  .title {
    padding: 14px 0 20px;
    margin: 0px;
  }
  .img-news {
    height: 315px;
    width: 100%;
  }
  .img-pd {
    padding: 40px 0 20px;
  }
  .info-news {
    padding-bottom: 50px;
    text-align: center;
  }
}
</style>